import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-zero': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM248 113.2C166.1 113.2 145.5 190.5 145.5 256 145.5 321.5 166.1 398.8 248 398.8S350.5 321.5 350.5 256C350.5 190.5 329.9 113.2 248 113.2zM248 167.1C251.3 167.1 254.4 167.6 257.2 168.3 263.1 173.4 266 180.4 260.3 190.2L205.8 290.4C204.1 277.7 203.9 265.3 203.9 256 203.9 227.2 205.9 167.1 248 167.1zM288.8 213.3C291.7 228.7 292.1 244.7 292.1 256 292.1 284.9 290.1 344.9 248 344.9 234.5 344.9 215.4 337.2 227.9 318.5L288.8 213.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-zero.js
// module id = jm5p
// module chunks = 144